import {
  AvailabilityPageLayout
} from "@pages/suppliers/_id/_products/investment-product/_id/view/components/availability";

interface ViewAvailabilityTabProps {}

export const ViewAvailabilityTab = (props: ViewAvailabilityTabProps) => {
  return <AvailabilityPageLayout/>;
};
